import { useTexture } from "@react-three/drei";
import { memo } from "react";

type Props = {
  size: [width?: number | undefined, height?: number | undefined];
  texture: string;
  opacity: number;
  circle?: boolean;
};

const TexturedPlane = (props: Props) => {
  const { size, texture, opacity, circle = false } = props;

  const cloudTexture = useTexture(texture);

  return (
    <mesh>
      {circle ? (
        // circleGeometry only needs 1 argument: radius
        <circleGeometry args={[size[0]! / 2, 64]} />
      ) : (
        <planeGeometry args={size} />
      )}
      <meshBasicMaterial
        map={cloudTexture}
        transparent
        opacity={opacity}
      />
    </mesh>
  );
};

export default memo(TexturedPlane);
